import { connect } from 'react-redux';

import { Dispatch, IAppState } from '../../../../../../../common/state';
import { wordExcludeAdded, wordExcludeRemoved } from '../../../../../../state/advanced/words_exclude';

import { WordsExclude as WordsExcludeComponent } from './wordsExclude';

export const mapStateToProps = (state: IAppState) => ({
  wordsExclude:
    (state.filters.jsonQuery.description_exclude && state.filters.jsonQuery.description_exclude.value) || [],
  isModerator: state.user.isAuthenticated && state.user.isModerator,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  onWordExcludeAdded: (word: string) => {
    dispatch(wordExcludeAdded(word));
  },
  onWordExcludeRemoved: (word: string) => {
    dispatch(wordExcludeRemoved(word));
  },
});

export const WordsExclude = connect(mapStateToProps, mapDispatchToProps)(WordsExcludeComponent);
